
export default {
  props: {
    title: {type: String, default: undefined},
    gotFilter: {type: Boolean, default: false},
    placement: {type: String, default: 'bottom-start'},
    filterIndicator: {type: Boolean, default: true}
  },
  data() {
    return {
      show: false,
    }
  },
  computed: {
    filter_indicator(){
      if (!this.filterIndicator) return false
      return this.gotFilter
    }
  }
}
